import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosColDirective } from './col.directive'


@NgModule({
  declarations: [IcosColDirective],
  exports: [IcosColDirective],
  imports: [CommonModule],
  entryComponents: [],
})
export class IcosColModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosColModule, providers: [] }
  }
}
